module.exports = __webpack_public_path__ + "img/calendar_blue.ae5bab71.svg";